import { useContext } from 'react';
import { UiStateContext } from '@frontend/components/contexts/uiState/uiStateContext';

export function useUiStateContext() {
    const uiStateContext = useContext(UiStateContext);

    if (!uiStateContext) {
        throw new Error('useUiState must be used within a UiStateProvider');
    }

    return uiStateContext;
}
